import { render, staticRenderFns } from "./CompraYeyi.vue?vue&type=template&id=0da2274e&"
import script from "./CompraYeyi.vue?vue&type=script&lang=js&"
export * from "./CompraYeyi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports